import React from "react";
import {store} from '@redux/store';
import actions from '@redux/EditableTable/actions';

export const Facility_CategoryProps = {
    title: 'Facility Category',
    description: '',
    name: 'facilityCategory',
}

const renderDrawer = (text, id) => {
    store.dispatch(actions.OpenDrawer(true, id))
}


export const Facility_CategoryColumns = [
    {
        title: 'key',
        dataIndex: 'id',
        key: 'id',
        editable: false,
        search: false,
        importIngore: true,
        width: '4%',
        hideInTable: true,
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        search: false,
        sorter: (a, b) => a.name?.localeCompare(b.name),
        render: (text, record, _, action) => (
            <a onClick={() => action ? renderDrawer(text, record.id) : ''}>{text}</a>
        )
    },
    {
        title: 'Color',
        dataIndex: 'color',
        key: 'color',
        width: '150px',
        hideInTable: window.innerWidth < 760,
        render: (text, record) => {
            if (!text) return '-';
            return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div 
                        style={{ 
                            width: '24px', 
                            height: '24px', 
                            backgroundColor: text,
                            border: '1px solid #ddd',
                            borderRadius: '4px'
                        }}
                    />
                    <span>{text}</span>
                </div>
            );
        }
    },
    {
        title: 'Created By',
        dataIndex: 'createdby_name',
        key: 'createdby_name',
        editable: false,
        hideInTable: window.innerWidth < 760,
    },
    {
        title: 'Modified By',
        dataIndex: 'modifiedby_name',
        key: 'modifiedby_name',
        editable: false,
        hideInTable: window.innerWidth < 760,
    },
    {
        title: '',
        valueType: 'option',
        width: '3rem',
        importIngore: true,
        render: (text, record, _, action) => (
            <a onClick={(e) => {
                e.stopPropagation();
                return action ? renderDrawer(text, record.id) : ''
            }}>
                <i className="fas fa-expand-arrows-alt text-lg"></i>
            </a>
        ),
    },
];

